module.exports = __webpack_public_path__ + "img/ge-field.831cf915.svg";